import React from 'react'
import PropTypes from 'prop-types'
import WorkAuthFields from '../WorkAuthFields'
import WorkAuthPreview from '../WorkAuthPreview'

export const WorkAuthItem = props => (
  <Choose>
    <When condition={props.editing}>
      <WorkAuthFields
        selectedCountries={props.selectedCountries}
        initialValues={props.initialValues}
        toggleFieldSection={props.toggleFieldSection}
        countryName={props.countryName}
        form={props.form}
        candidateId={props.candidateId}
        countryIso2Code={props.countryIso2Code}
        allCountries={props.allCountries}
        isCreatingCitizenship={props.isCreatingCitizenship}
        isUpdatingCitizenship={props.isUpdatingCitizenship}
        validateCountry={props.validateCountry}
        control={props.control}
        errors={props.errors}
        submitForm={props.submitForm}
        index={props.index}
      />
    </When>
    <Otherwise>
      <WorkAuthPreview
        workAuthId={props.workAuthId}
        countryName={props.countryName}
        toggleFieldSection={props.toggleFieldSection}
        citizenshipStatus={props.citizenshipStatus}
        permitType={props.permitType}
        countryIso2Code={props.countryIso2Code}
        isDeletingCitizenship={props.isDeletingCitizenship}
        deleteCitizenship={props.deleteCitizenship}
      />
    </Otherwise>
  </Choose>
)

const { bool, string, func, shape, number, arrayOf } = PropTypes
WorkAuthItem.propTypes = {
  editing: bool,
  initialValues: shape({ citizenshipStatus: string }),
  toggleFieldSection: func,
  countryName: string,
  citizenshipStatus: string,
  permitType: string,
  form: string,
  candidateId: string,
  countryIso2Code: string,
  allCountries: arrayOf(shape()),
  workAuthId: string,
  selectedCountries: arrayOf(string),
  isDeletingCitizenship: bool,
  deleteCitizenship: func,
  isCreatingCitizenship: bool,
  isUpdatingCitizenship: bool,
  validateCountry: func,
  control: shape(),
  errors: shape(),
  submitForm: func,
  index: number,
}
